/**
 * The below file is the Fire Cause service which contains method for doing the API calls.
 * @author: shivam.sharma2@velsof.com
 * @date : 10-01-2023
 */

import fetch from "auth/FetchInterceptor";
import {
  Application_Json,
  Authorization_Token,
  Get_All_Flood_Death_Cause,
} from "constants/ApiConstant";
import { format } from "react-string-format";
import { AUTH_TOKEN } from "redux/constants/Auth";

const FloodDeathCauseServices = {};

//#region Method for Fire Cause dropdown

/**
 * Method for getting the Fire Cause dropdown
 * @param {any} param API Parameters
 * @returns Fetch Method
 */
FloodDeathCauseServices.getAllFloodDeathCause = function () {
  return fetch({
    url: Get_All_Flood_Death_Cause,
    method: "get",
    headers: {
      "Content-Type": Application_Json,
      Authorization: format(
        Authorization_Token,
        localStorage.getItem(AUTH_TOKEN)
      ),
    },
  });
};

//#endregion Method for Fire Cause dropdown.

export default FloodDeathCauseServices;
